import React, { createContext, useState, useEffect, useMemo } from 'react';
import * as authService from '../../services/auth';

export const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const initAuth = () => {
      try {
        const storedToken = localStorage.getItem('accessToken');
        const storedUser = authService.getCurrentUser();

        if (storedToken && storedUser) {
          setToken(storedToken);
          setUser(storedUser);
        }
      } catch (error) {
        console.error('Error initializing auth:', error);
        localStorage.removeItem('accessToken');
        localStorage.removeItem('user');
      } finally {
        setLoading(false);
      }
    };

    initAuth();
  }, []);


  const login = async (credentials) => {
    try {
      const response = await authService.login(credentials);
      
      const { accessToken: newToken, user: newUser, token: responseToken } = response;

      // El servicio puede retornar 'token' o 'accessToken'
      const finalToken = newToken || responseToken;
      const finalUser = newUser || response.user;

      setToken(finalToken);
      setUser(finalUser);

      localStorage.setItem('accessToken', finalToken);
      localStorage.setItem('user', JSON.stringify(finalUser));
      
      return finalUser;
    } catch (error) {
      console.error('Login failed:', error);
      throw error;
    }
  };


  const logout = async () => {
    try {
      await authService.logout();
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      setUser(null);
      setToken(null);
      
      localStorage.removeItem('accessToken');
      localStorage.removeItem('user');
    }
  };

  // Usar useMemo para recalcular isAuthenticated cuando token cambie
  const isAuthenticated = useMemo(() => {
    return !!token;
  }, [token]);

  const value = useMemo(() => ({
    user,
    token,
    loading,
    isAuthenticated,
    login,
    logout,
  }), [user, token, loading, isAuthenticated]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export default AuthProvider;

